// extracted by mini-css-extract-plugin
module.exports = {"tip":"images_tip__T4zY2","wrapper":"images_wrapper__ji6aq","aspectRatioWrapper":"images_aspectRatioWrapper__UybRQ","aspectRatio":"images_aspectRatio__OcXsA"};